import { createPortal } from 'react-dom';
import { Breadcrumb } from '@/components/Breadcrumb';
import { usePageData } from '@/contexts/pageContext';

const breadcrumbPortal = document.querySelector('.header__breadcrumb');

export const useBreadcrumb = () => {
  const { referrer } = document;
  const showBackLink = referrer.includes('easons.com');

  const { breadcrumbLinks } = usePageData();

  if (!breadcrumbLinks) {
    return null;
  }

  const breadcrumbProps = {
    ...(showBackLink ? { backLink: referrer } : {}),
    breadcrumbLinks,
  };

  return breadcrumbPortal
    ? createPortal(<Breadcrumb {...breadcrumbProps} />, breadcrumbPortal)
    : null;
};
